export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";